
import React from "react";
import "./ShippingPolicy.css";

const ShippingPolicy = () => {
  return (
    <div className="shipping-policy-page">
      <div className="shipping-policy-hero">
        <div className="container">
          <span className="policy-badge">Shipping Policy</span>
          <h1>Shipping & Delivery Information</h1>
          <p>
            We aim to process and deliver your orders as quickly and safely as
            possible. Please read the details below to understand how shipping,
            delivery timelines, and order tracking work.
          </p>
        </div>
      </div>

      <div className="container shipping-policy-content">
        <div className="policy-card">
          <h2>Order Processing Time</h2>
          <p>
            Orders are usually processed within 1 to 3 business days after
            payment is successfully confirmed.
          </p>
          <p>
            Orders placed on Sundays or public holidays may be processed on the
            next working day.
          </p>
        </div>

        <div className="policy-card">
          <h2>Shipping Charges</h2>
          <p>
            Shipping charges, if applicable, will be shown during checkout
            before you complete your purchase.
          </p>
          <p>
            From time to time, we may offer free shipping promotions on selected
            products, categories, or minimum order values.
          </p>
        </div>

        <div className="policy-card">
          <h2>Estimated Delivery Time</h2>
          <p>
            Estimated delivery timelines usually range between 3 to 7 business
            days depending on your delivery location.
          </p>
          <p>
            Delivery to remote or non-serviceable areas may take longer than the
            standard timeline.
          </p>
        </div>

        <div className="policy-card">
          <h2>Order Tracking</h2>
          <p>
            Once your order is shipped, tracking details will be shared through
            the registered email address or phone number, if available.
          </p>
          <p>
            You can also check your order status from your account orders
            section when tracking updates are available.
          </p>
        </div>

        <div className="policy-card">
          <h2>Delivery Delays</h2>
          <p>
            While we try our best to deliver within the estimated timeline,
            delays may happen because of courier issues, weather conditions,
            public holidays, natural disruptions, or high order volume.
          </p>
          <p>
            In such cases, we request your patience and understanding while the
            shipment is in transit.
          </p>
        </div>

        <div className="policy-card">
          <h2>Incorrect Address Details</h2>
          <p>
            Customers are responsible for entering the correct shipping address,
            contact number, and recipient details at the time of placing the
            order.
          </p>
          <p>
            We may not be able to guarantee delivery or re-shipping if the
            address submitted is incomplete, incorrect, or unreachable.
          </p>
        </div>

        <div className="policy-card">
          <h2>Failed Delivery Attempts</h2>
          <p>
            If a delivery attempt fails because the recipient is unavailable,
            the courier partner may attempt re-delivery based on their service
            policy.
          </p>
          <p>
            If the shipment is returned to us after repeated failed attempts,
            additional shipping charges may apply for re-dispatch.
          </p>
        </div>

        <div className="policy-card">
          <h2>Damaged or Tampered Packages</h2>
          <p>
            If your package appears damaged, opened, or tampered with at the
            time of delivery, please do not accept it if possible and contact
            our support team immediately.
          </p>
          <p>
            Sharing photos of the package and order details will help us resolve
            the issue faster.
          </p>
        </div>

        <div className="policy-card">
          <h2>International Shipping</h2>
          <p>
            International shipping availability depends on the products and
            destination country.
          </p>
          <p>
            Additional customs duties, taxes, or import fees, if applicable,
            are the responsibility of the customer unless stated otherwise at
            checkout.
          </p>
        </div>

        <div className="policy-card">
          <h2>Need Help?</h2>
          <p>
            If you have any questions related to shipping, delivery status, or
            order support, please contact our customer service team through the
            contact page or support details provided on the website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;